interface CardBrandIconProps {
  brand?: string;
  className?: string;
}

const brandStyles: Record<string, { bg: string; text: string; label: string }> = {
  visa: { bg: "#1a1f71", text: "#ffffff", label: "VISA" },
  mastercard: { bg: "#2d2d2d", text: "#ffffff", label: "" },
  amex: { bg: "#016fd0", text: "#ffffff", label: "AMEX" },
  link: { bg: "#00d66f", text: "#0a2540", label: "LINK" },
  discover: { bg: "#ff6000", text: "#ffffff", label: "DISCOVER" },
  jcb: { bg: "#2b4b94", text: "#ffffff", label: "JCB" },
  diners: { bg: "#004e94", text: "#ffffff", label: "DINERS" },
  unionpay: { bg: "#c8102e", text: "#ffffff", label: "UNIONPAY" },
};

export default function CardBrandIcon({ brand = "unknown", className = "" }: CardBrandIconProps) {
  const b = brand.toLowerCase();
  const style = brandStyles[b] || { bg: "#6b7280", text: "#ffffff", label: b.toUpperCase() };

  if (b === "mastercard") {
    return (
      <svg viewBox="0 0 48 30" className={className} aria-label="Mastercard">
        <rect width="48" height="30" rx="4" fill="#2d2d2d" />
        <circle cx="18" cy="15" r="10" fill="#eb001b" opacity="0.9" />
        <circle cx="30" cy="15" r="10" fill="#f79e1b" opacity="0.9" />
        <path d="M24 8a10 10 0 0 1 0 14 10 10 0 0 1 0-14z" fill="#ff5f00" opacity="0.85" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 48 30" className={className} aria-label={style.label}>
      <rect width="48" height="30" rx="4" fill={style.bg} />
      <text
        x="24"
        y="19"
        textAnchor="middle"
        fill={style.text}
        fontSize="10"
        fontWeight="700"
        fontFamily="system-ui, sans-serif"
        letterSpacing={b === "visa" ? "0.8" : "0.2"}
      >
        {style.label}
      </text>
    </svg>
  );
}
